module.exports = __webpack_public_path__ + "img/28_59.4baea739.png";